import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { graphql } from "../gql";
import { GetOnboardingLiveCreationIntentsQuery } from "./useOnboardingLiveCreationIntents.ts";

const CreateIntentMutation = graphql(`
  mutation createOnboardingLiveCreationIntent($userGroupId: String!) {
    createOnboardingLiveCreationIntent(userGroupId: $userGroupId) {
      id
    }
  }
`);

export function useCreateOnboardingLiveCreationIntent() {
  const [createMutation, { loading: creating }] = useMutation(
    CreateIntentMutation,
    { refetchQueries: [GetOnboardingLiveCreationIntentsQuery] },
  );
  const createIntent = useCallback(
    async (userGroupId: string) => {
      const { data } = await createMutation({ variables: { userGroupId } });
      const intentId = data?.createOnboardingLiveCreationIntent.id;
      if (!intentId) throw new Error("Plan not created");
      return intentId;
    },
    [createMutation],
  );
  return { createIntent, creating };
}
